var $ = require("./lib/qsa");
var knownStations = require("../../data/stations.sheet.json");

var loadStations = async function () {
  var response = await fetch(
    "https://api.npr.org/stationfinder/v3/stations/recommendations"
  );
  return response.json();
};

var getStation = async function () {
  var stationInfo = {};
  var url = new URL(window.location);
  var station = url.searchParams.get("station");

  // If valid station passed in as url param, use that. Else grab it from API
  if (knownStations[station]) {
    stationInfo.stationName = station;
    stationInfo.stationLink = knownStations[station].link;
    stationInfo.stationLogo = knownStations[station].logo;
  } else {
    var json = await Promise.all([loadStations()]);

    // Get first station returned from API;
    var item = json[0].items[0];
    if (item) {
      stationInfo.stationName = item.attributes.brand.call;
      stationInfo.stationLink = item.links.brand.filter(
        a => a.rel == "homepage"
      )[0].href;
      stationInfo.stationLogo = item.links.brand.filter(
        a => a.rel == "logo"
      )[0].href;
    }
  }

  return stationInfo;
};

var setStation = function (station) {
  if (!station.stationLink) return;
  $(".station-url").forEach(function (i) {
    i.href = station.stationLink;
  });
  $(".station-img").forEach(function (i) {
    i.classList.remove('hidden');
    i.src = station.stationLogo;
    i.alt = station.stationName;
  });
};

module.exports = { getStation, setStation };
